//import "url-search-params-polyfill";
import { languages } from "../ReplayVariables";

const myDetector = {
  name: "myDetector",

  lookup(options) {
    // options -> are passed in options
    //console.log("lng", window.location);
    let lng = "en";
    let params = document.location.pathname.split("/");
    if (params.length >= 2) {
      lng = params[2];
      console.log("Detected language:", lng);
      if (languages.includes(lng)) {
        localStorage.setItem("lng", lng);
        return lng;
      } else {
        if (params.length >= 3) {
          if (
            lng === "s" ||
            lng === "e" ||
            lng === "a" ||
            lng === "as" ||
            lng === "ea" ||
            lng === "w"
          ) {
            let _lng = this.getOtherLanguage();
            let redir = "/opencards/" + _lng + "/" + lng + "/" + params[3];
            document.location.href = redir;
          }
        }
      }
    }
    lng = this.getOtherLanguage();
    return lng;
  },

  getOtherLanguage() {
    console.log("getOtherLanguage");
    let lng = localStorage.getItem("lng");
    if (languages.includes(lng)) {
      return lng;
    }
    var userLang = navigator.language || navigator.userLanguage;
    //console.log("The language is(1): " + userLang);
    if (userLang.indexOf("-") !== -1) {
      //console.log("Final language is: " + userLang.split("-")[0]);
      lng = userLang.split("-")[0];
      localStorage.setItem("lng", lng);
      return lng;
    }
    if (userLang.indexOf("_") !== -1) {
      //console.log("Final language is: " + userLang.split("_")[0]);
      lng = userLang.split("_")[0];
      localStorage.setItem("lng", lng);
      return lng;
    }
    localStorage.setItem("lng", "en");
    return "en";
  },

  cacheUserLanguage(lng, options) {
    // options -> are passed in options
    // lng -> current language, will be called after init and on changeLanguage
    // store it
  },
};

export default myDetector;
